import React, { Fragment } from "react"
import Styled from "styled-components"
import Project from "./Project"
import { Wrapper } from "./globalStyles"
import image from "../images/capture.png"
import image2 from "../images/capture2.png"
import image3 from "../images/capture3.png"
import image4 from "../images/capture4.png"
const Projects = () => {
  return (
    <Fragment>
      <h1>Work in Progress</h1>
      <Wrapper>
        <Project
          imgClass="img1"
          text="Card Directory"
          explain="Search for Cards"
          image={image}
          textColor="white"
          bColor="orange"
          site="https://jolly-shockley-5a15e4.netlify.app"
        />
        <Project
          imgClass="img2"
          text="Alive"
          explain="log in / checkout"
          image={image2}
          textColor="white"
          bColor="orange"
          site="https://peaceful-varahamihira-e755f4.netlify.app"
        />
        <Project
          imgClass="img3"
          text="WellsForgot"
          explain="bank app"
          image={image3}
          textColor="white"
          bColor="orange"
          site="https://wellsforgot.herokuapp.com/"
        />
        <Project
          imgClass="img4"
          explain="Search for Events"
          text="findEvent"
          image={image4}
          textColor="white"
          bColor="orange"
          site="https://keen-wescoff-5b4f1d.netlify.app/"
        />
      </Wrapper>
    </Fragment>
  )
}
export default Projects
